const relativePath = value => String(value || '')
  .replace(/\\/g, '/')
  .split('/')
  .filter(Boolean)
  .join('/');

// Results are positional, matching SimpleUploadService.uploadFiles. Never
// identify an upload by its basename: sibling folders can contain the same name.
export const buildDocumentUploadRetrySelection = (items, results) => {
  const rows = Array.from(items || []);
  const files = rows.filter(item => item?.file);
  const settled = Array.isArray(results) ? results : [];
  const retryIndexes = [];
  const unresolvedIndexes = [];
  let completedCount = 0;

  files.forEach((item, index) => {
    const result = settled[index];
    if (result?.status === 'fulfilled') {
      completedCount += 1;
    } else if (result?.status === 'rejected'
      && result.reason?.uploadOutcome !== 'unknown'
      && result.reason?.retryable !== false) {
      // Legacy rejected results remain available for an explicit manual retry.
      // New uncertain transport/server responses must opt out via either flag.
      retryIndexes.push(index);
    } else {
      // A missing/nonterminal result is not proof that the server rejected it.
      unresolvedIndexes.push(index);
    }
  });

  const ancestorPaths = new Set();
  retryIndexes.forEach(index => {
    const parts = relativePath(files[index].relativePath
      || files[index].file.webkitRelativePath
      || files[index].originalName).split('/');
    parts.pop();
    parts.forEach((part, partIndex) => ancestorPaths.add(parts.slice(0, partIndex + 1).join('/')));
  });
  const folders = rows.filter(item => item && !item.file && ancestorPaths.has(relativePath(
    item.originalPath || item.relativePath || item.originalName,
  )));

  return {
    retryItems: [...folders, ...retryIndexes.map(index => files[index])].map(item => ({ ...item })),
    retryIndexes,
    unresolvedIndexes,
    completedCount,
  };
};
